import utilsInstance from "./Utils.js";
import plotMgrInstance from "./PlotMgr.js"
import * as d3 from "d3";
import {Plot} from "./Plot.js"

class PiePlot extends Plot {
    constructor(initParams) {
        let _defaultParams = plotMgrInstance.parameters;
        _defaultParams.backgroundColor = "white";
        _defaultParams.labelColor = "white";
        _defaultParams.selectionColor = "#0000ff";
        _defaultParams.outlineColor = "white";
        _defaultParams.highlightOpacity = 0.5;
        _defaultParams.colorScheme = null;
        _defaultParams.outerRadiusOfPieChart = 100;
        let params = { ..._defaultParams, ...(initParams || {}) };
        super(params)
        this.outlineColor = params.outlineColor;
        this.colorScheme = params.colorScheme;
        this.outerRadiusOfPieChart = params.outerRadiusOfPieChart;
        this.temp_pick = [];
        this.group = null;
        this.type ="PiePlot"
    }

    addPiePlot(newData, idForPlotCreation, keyForPlotCreation, layoutType, idKeyValue = undefined) {
        try {
            let scope = this;
            
            // Determine size of arcs
            let arc = d3.arc()
                .innerRadius(0)
                .outerRadius(scope.outerRadiusOfPieChart);

            let dataArr = [];
            // Create the pie plot layout for number or count layout type
            if (layoutType == 'value') {
                if (keyForPlotCreation == 'string' || keyForPlotCreation == 'bool') {
                    error.textContent = "Failed to add pie plot for string using number layout type"
                }
                else {
                    let response = utilsInstance.filterNumberTypeData(newData, idForPlotCreation, keyForPlotCreation, idKeyValue);
                    if (response.status == 'success') {
                        dataArr = response.data;
                    }
                }
            }
            // Create the pie plot layout for string, bool and date datatype
            else {
                let response = utilsInstance.filterOtherTypeData(newData, idForPlotCreation, keyForPlotCreation, idKeyValue);
                if (response.status == 'success') {
                    dataArr = response.data;
                }
            }

            // arc colors
            let arcColor;
            if (scope.colorScheme == 'sequential') {
                arcColor = d3.scaleOrdinal(d3.schemeGreys[9]);
            }
            else if (scope.selectElements.colorScheme == 'categorical') {
                arcColor = d3.scaleOrdinal(d3.schemeSet3);
            }
            else if (scope.colorScheme == null) {
                arcColor = d3.scaleOrdinal().range(['#555555', '#555555', '#555555', '#555555', '#555555', '#555555', '#555555', '#555555', '#555555', '#555555'])
            }

            let pie = d3.pie()
                .value(function (d) {
                    return d.value;
                })
                .sort(null);

            let dimensions = "0 0 " + canvas.offsetWidth + " " + canvas.offsetHeight;
            let plotContainer = d3.select(scope.canvas).append("svg")
                .attr("viewBox", dimensions)
                .attr("preserveAspectRatio", "xMinYMin meet");

            let plotCanvas = plotContainer
                .append("g")
                .attr("transform", "translate(" + scope.canvas.clientWidth / 2 + "," + scope.canvas.clientHeight / 2 + ")");

            // Define inner circle
            plotCanvas.append("circle")
                .attr("cx", 0)
                .attr("cy", 0)
                .attr("opacity", scope.highlightOpacity)

            // Calculate SVG paths and fill in the colours
            scope.group = plotCanvas.selectAll(".arc")
                .data(pie(dataArr))
                .enter().append("g")
                .attr("class", "arc")

            // Append the path to each g
            scope.group.append("path")
                .attr("d", arc)
                .attr("fill", function (d, i) {
                    return arcColor(i);
                })
                .attr("stroke", scope.outlineColor)

            let plotLabels = plotCanvas.selectAll(".labels")
                .data(pie(dataArr))
                .enter().append("g")
                .attr("class", "labels")
                .style("pointer-events", "none") // resrticted mouse events
                .style("user-select", "none") // stanard
                .style("-webkit-user-select", "none") // safari
                .style("-ms-user-select", "none"); // IE10 and IE11

            // Append text labels to each arc
            plotLabels.append("text")
                .attr("transform", function (d) {
                    return "translate(" + arc.centroid(d) + ")";
                })
                .attr("dy", ".35em")
                .style("text-anchor", "middle")
                .attr("fill", scope.labelColor)
                .text(function (d, i) {
                    if (typeof (d.data.key) == 'number') {
                        let decimalFactor = plotMgrInstance.getDefaultParams();
                        return d.data.key.toFixed(decimalFactor).replace(/\.0+$/, '');
                    }
                    else {
                        return d.data.key;
                    }
                });
            let returnValue = {
                "status": "success",
                "message": "Pie plot added"
            }
            return returnValue;
        }
        catch (err) {
            let returnValue = {
                "status": "failed",
                "message": "Failed to add pie plot." + err.message
            }
            return returnValue;
        }
    }

    // █████ █████ █     █████  ████ █████ 
    // █     █     █     █     █       █   
    // █████ ████  █     ████  █       █   
    //     █ █     █     █     █       █   
    // █████ █████ █████ █████  ████   █  

     // SELECTION event
     getSelectedElementsCondition(group, selectedElement, callBack, ids){
        let scope = this;

        if (group.__data__ != undefined) {
            group.__data__.data.ids.forEach(id => {
                scope.arrayElements.push(id)
            });
            scope.applySelectionColor(selectedElement);
            callBack([...new Set(scope.arrayElements)]);
        }
        else {
            callBack("");
            plotMgrInstance.deSelectElementsInAllPlots();
        }
    }

    applyPartialSelectionColor(element) {
        let scope = this;
        
        let svg = d3.select(scope.canvas).append("svg");
        svg
            .append('defs')
            .append('pattern')
            .attr('id', 'diagonalHatch')
            .attr('patternUnits', 'userSpaceOnUse')
            .attr('width', 4)
            .attr('height', 8)
            .attr('patternTransform', 'rotate(-45 2 2)')
            .append('path')
            .attr('d', 'M -1,2 l 6,0')
            .style("stroke", scope.selectionColor)
            .style("stroke-width", "5")
            .style('stroke-opacity', '0.75');

        scope.temp_pick.push(element)
        element.style('fill', 'url(#diagonalHatch)');
        element.attr('name', 'partialElement');
    }

    selectElements(elementIDs) {
        let scope = this;
        
        let selectedElement = [];
        if (scope.group != undefined) {
            for (let i = 0; i < scope.group._groups[0].length; i++) {
                let counter = 0;
                let elementID = scope.group._groups[0][i].__data__.data.ids;
                for (let j = 0; j < elementIDs.length; j++) {
                    for (let k = 0; k < elementID.length; k++) {
                        if (elementID[k] == elementIDs[j]) {
                            counter++;
                        }
                    }
                }
                if (counter == elementID.length) {
                    selectedElement = scope.group._groups[0][i]
                    if (selectedElement.className['baseVal'] == 'arc') {
                        let element = d3.select(selectedElement.childNodes[0])
                        if (element != undefined) {
                            if (scope.group != selectedElement.childNodes[0]) {
                                scope.applySelectionColor(element);
                            }
                        }
                    }
                }
                else if (counter > 0 && counter <= elementIDs.length) {
                    selectedElement = scope.group._groups[0][i]
                    if (selectedElement.className['baseVal'] == 'arc') {
                        let element = d3.select(selectedElement.childNodes[0])
                        if (element != undefined) {
                            if (scope.group != selectedElement.childNodes[0]) {
                                scope.applyPartialSelectionColor(element);
                            }
                        }
                    }
                }
            }
        }
    }

    // Clear pick selection
    clearSelection() {
        let scope = this;
        
        if (!scope.multipleSelectionFlagCheck) {
            for (let i = 0; i < scope.temp_pick.length; i++) {
                let element = scope.temp_pick[i];

                if (element.attr('name') == "pickElement") {
                    element.attr('name', null);
                    element.style("fill", "")
                }
                else if (element.attr('name') == "partialElement") {
                    element.attr('name', null);
                    element.style("fill", "")
                }
            }
            scope.temp_pick = [];
            scope.arrayElements = [];
        }
    }

    // Clear all pick selection
    clearAllPickSelection() {
        let scope = this;
        
        for (let i = 0; i < scope.temp_pick.length; i++) {
            let element = this.selectElements.temp_pick[i];

            if (element.attr('name') == "pickElement") {
                element.attr('name', null);
                element.style("fill", "");
            }
            else if (element.attr('name') == "partialElement") {
                element.attr('name', null);
                element.style("fill", "")
            }
        }
        scope.temp_pick = [];
        scope.arrayElements = [];
    }

    // █   █ █████  ████ █   █ █     █████  ████ █   █ █████ 
    // █   █   █   █     █   █ █       █   █     █   █   █   
    // █████   █   █  ██ █████ █       █   █  ██ █████   █   
    // █   █   █   █   █ █   █ █       █   █   █ █   █   █   
    // █   █ █████  ███  █   █ █████ █████  ███  █   █   █ 

    // Highlight event
    highlightElement(event, callBack) {
        let scope = this;
        
        if (scope.highlightElementFlagCheck) {
            let group = event.target;
            let highlightedElement;
            plotMgrInstance.deHighlightElementsInAllPlots();
            if (highlightedElement = d3.select(group)) {
                if (group.__data__ != undefined) {
                    callBack(group.__data__.data.ids);
                    let parentElement = group.parentElement.parentElement.childNodes;
                    for (let i = 1; i < parentElement.length; i++) {
                        let elementdata = parentElement[i];
                        if (elementdata.className['baseVal'] == 'arc') {
                            let element = d3.select(elementdata.childNodes[0])
                            if (element != undefined) {
                                if (group != elementdata.childNodes[0]) {
                                    scope.applyHighlightTransparency(element);
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    highlightElements(elementIDs) {
        let scope = this;
        
        let highlightedElement = [];
        if (scope.group != undefined) {
            for (let i = 0; i < scope.group._groups[0].length; i++) {
                let counter = 0;
                let elementID = scope.group._groups[0][i].__data__.data.ids;
                for (let j = 0; j < elementIDs.length; j++) {
                    for (let k = 0; k < elementID.length; k++) {
                        if (elementID[k] != elementIDs[j]) { counter++ }
                    }
                }
                if (counter == elementID.length) {
                    highlightedElement = scope.group._groups[0][i]
                    if (highlightedElement.className['baseVal'] == 'arc') {
                        let element = d3.select(highlightedElement.childNodes[0])
                        if (element != undefined) {
                            if (scope.group != highlightedElement.childNodes[0]) {
                                scope.applyHighlightTransparency(element);
                            }
                        }
                    }
                }
                else if (counter > 0 && counter <= elementIDs.length) {
                    highlightedElement = scope.group._groups[0][i]
                    if (highlightedElement.className['baseVal'] == 'arc') {
                        let element = d3.select(highlightedElement.childNodes[0])
                        if (element != undefined) {
                            if (scope.group != highlightedElement.childNodes[0]) {
                                scope.applyHighlightTransparency(element);
                            }
                        }
                    }
                }
            }
        }
    }

     // Clear highlight selection 
     clearHighlights() {
        let scope = this;
        
        for (let i = 0; i < scope.temp_highlight.length; i++) {
            let element = scope.temp_highlight[i];

            if (element.attr("name") == "pickElement") {
                element.style("fill", scope.selectionColor);
                element.style("opacity", "1");
            }
            else if (element.attr("name") == "partialElement") {
                let svg = d3.select(scope.canvas).append("svg");
                svg
                    .append('defs')
                    .append('pattern')
                    .attr('id', 'diagonalHatch')
                    .attr('patternUnits', 'userSpaceOnUse')
                    .attr('width', 4)
                    .attr('height', 8)
                    .attr('patternTransform', 'rotate(-45 2 2)')
                    .append('path')
                    .attr('d', 'M -1,2 l 6,0')
                    .style("stroke", scope.selectionColor)
                    .style("stroke-width", "5")
                    .style('stroke-opacity', '0.75');

                scope.temp_pick.push(element)
                element.style('fill', 'url(#diagonalHatch)');
                element.style("opacity", "1");
            }
            else {
                element.style("opacity", "1");
            }
        }
        scope.temp_highlight = [];
    }
}
export { PiePlot }